//忠诚度管理-奖品中心
import { get, post, postJson, put, putUrl } from "@/api/jhk/axios.js";

//令牌汇总
export const promoTokenSum = (p) => get(`/promoToken/sum`, p)

//令牌分页查询
export const promoTokenPage = (p) => get(`/promoToken/page`, p)

//添加令牌
export const addPromoTokenPage = (p) => postJson(`/promoToken/add`, p)

//修改令牌
export const updatePromoTokenPage = (p) => postJson(`/promoToken/update`, p)

//数据明细
export const promoTokenSumDetail = (p) => get(`/promoToken/send/page`, p)

//令牌详情接口
export const promoTokenDetail = (p) => get(`/promoToken/detail`, p)
